import '@/shared/configs/i18n.config';

import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import {
	createBrowserRouter,
	createRoutesFromChildren,
	matchRoutes,
	RouterProvider,
	useLocation,
	useNavigationType,
} from 'react-router-dom';

import { App } from '@/app';
import { ErrorBoundary } from '@/app/providers/error-boundary';
import { StoreProvider } from '@/app/providers/store';

Sentry.init({
	dsn: 'https://b42d606a17a9368b4bef2cb41a01b0c9@o4510487588306944.ingest.de.sentry.io/4510512767369296',
	environment: SENTRY_ENV,
	// environment: 'dev',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	integrations: [
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
	],
	tracesSampleRate: 1.0,
});
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const rootElement = document.getElementById('root');

export const router = sentryCreateBrowserRouter([
	{
		path: '/*',
		element: <App />,
	},
]);

if (rootElement) {
	const root = createRoot(rootElement);

	root.render(
		<StoreProvider>
			<HelmetProvider>
				<ErrorBoundary>
					<RouterProvider router={router} />
				</ErrorBoundary>
			</HelmetProvider>
		</StoreProvider>,
	);
} else {
	throw new Error('Root container missing in index.html');
}
